import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_53: FaireProductEntity = {
  token: "catalog_prod_prod-53",
  type: "product",
  name: "Paper Pendant Light - Accordion Fold",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 88.41,
  msrpDollars: 221.02,
  sku: "JA0053",
  caseSize: 3,
  material: "Glass",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 114,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
